import React from 'react';

import { StyledTag } from './styled';

export const Tag: React.FC = ({ children }) => {
  return <StyledTag>{children}</StyledTag>;
};
